var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parent",staticStyle:{"height":"20px","width":"20px","border":"thin solid red"}})
}
var staticRenderFns = []

export { render, staticRenderFns }